export default "__VITE_ASSET__O7qm6l6n__"